import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { specialServices, ultimateImages } from '../../data/ultimateData';

const UltimateServices = () => {
 const scrollToForm = () => {
 if (typeof window.fbq === 'function') {
 window.fbq('track', 'ViewContent', { content_name: 'Service Card Click' });
 }
 const formSection = document.getElementById('contact-form-section');
 if (formSection) formSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
 };

 return (
 <section className="relative py-16 sm:py-24 overflow-hidden" data-testid="services-section" id="services-section" style={{ background: "linear-gradient(180deg, rgba(9,9,12,0.94) 0%, rgba(9,9,12,0.90) 50%, rgba(9,9,12,0.96) 100%), url('/img/8a9ab622.webp') center/cover no-repeat fixed" }}>
 
 {/* Background Effects - Purple */}
 <div className="absolute inset-0">
 <div className="absolute top-1/4 right-0 w-96 h-96 bg-[#0B0B0E] rounded-full blur-3xl" />
 <div className="absolute bottom-1/4 left-0 w-80 h-80 bg-pink-500/10 rounded-full blur-3xl" />
 </div>
 
 <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">

 {/* Section Header */}
 <div className="text-center mb-12">
 <span className="inline-block tracking-[0.3em] text-[#C9A23A] font-bold text-sm mb-3 uppercase">
 हमारी सेवाएं
 </span>
 <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black mb-4" style={{ fontFamily: "'Rozha One', serif" }}>
 <span className="">
 विशेष तांत्रिक साधनाएं
 </span>
 </h2>
 <p className="text-[#D8D2C6] text-lg max-w-3xl mx-auto">
 हर समस्या के लिए <span className="text-[#F3EDE2] font-bold">विशेष साधना</span> - 100% गोपनीय और प्रभावी
 </p>
 </div>

 {/* Services Carousel */}
 <div className="max-w-7xl mx-auto">
 <Swiper
 modules={[Pagination, Autoplay]}
 spaceBetween={24}
 slidesPerView={1}
 pagination={{ clickable: true, bulletClass: 'swiper-pagination-bullet !bg-red-700/50 !w-3 !h-3', bulletActiveClass: '!bg-[#d4a84b] !scale-125' }}
 autoplay={{ delay: 5000, disableOnInteraction: false }}
 breakpoints={{
 640: { slidesPerView: 2 },
 1024: { slidesPerView: 3 },
 }}
 className="pb-12"
 >
 {specialServices.map((service, index) => (
 <SwiperSlide key={service.id}>
 <div 
 className="h-full p-6 rounded-2xl bg-gradient-to-br from-red-900/40 to-red-950/40 border border-[#d4a84b]/20 hover:border-[#d4a84b]/40 transition-all group cursor-pointer"
 data-testid={`service-card-${service.id}`}
 onClick={scrollToForm}
 >
 {/* Service Image */}
 {service.image && ultimateImages[service.image] && (
 <div className="mb-4 rounded-xl overflow-hidden h-40 border border-[#d4a84b]/20">
 <img src={ultimateImages[service.image]} alt={service.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform" />
 </div>
 )}

 {/* Badge */}
 <div className="flex justify-between items-start mb-4">
 <span className="px-4 py-2 bg-gradient-to-r from-amber-600 to-pink-600 text-[#D8D2C6] text-sm font-bold rounded-full">
 #{index + 1} विशेष साधना
 </span>
 <span className="text-3xl">{['❖', '🔱', '◈', '✦', '⚔️', '🕉'][index] || '✦'}</span>
 </div>

 {/* Title */}
 <h3 className="text-xl font-bold " style={{ fontFamily: "'Rozha One', serif" }}>
 {service.title}
 </h3>
 <p className="text-[#D8D2C6]/80 text-sm mb-4">{service.subtitle}</p>

 {/* Description */}
 <p className="text-[#D8D2C6]/90 text-sm mb-4 line-clamp-2">{service.description}</p>

 {/* Process */}
 <div className="mb-4">
 <h4 className="text-sm font-bold text-[#F3EDE2] mb-2">साधना प्रक्रिया:</h4>
 <div className="space-y-1">
 {service.process.slice(0, 2).map((step, i) => (
 <div key={i} className="flex items-start gap-2">
 <span className="w-5 h-5 rounded-full bg-red-700/20 text-[#F3EDE2] text-xs flex items-center justify-center flex-shrink-0">{i + 1}</span>
 <p className="text-xs text-[#D8D2C6]/80">{step.substring(0, 50)}...</p>
 </div>
 ))}
 </div>
 </div>

 {/* Fee & Duration */}
 <div className="grid grid-cols-2 gap-3 mb-4">
 <div className="p-3 rounded-lg text-center bg-[#0B0B0E] border border-[#d4a84b]/30">
 <div className="text-sm font-bold text-[#F3EDE2]">क्षमतानुसार दक्षिणा</div>
 
 </div>
 <div className="p-3 rounded-lg text-center bg-[#0B0B0E] border border-[#d4a84b]/60">
 <div className="text-sm font-bold text-[#D8D2C6]">{service.duration}</div>
 <div className="text-xs text-[#D8D2C6]/80">अवधि</div>
 </div>
 </div>

 {/* CTA */}
 <button 
 className="w-full py-3 font-bold rounded-lg text-sm transition-all hover:scale-105" style={{ background: 'linear-gradient(135deg, #6E0F0F, #A31515)', color: '#F5E7C8', border: '1.5px solid #C9A23A', boxShadow: '0 6px 20px rgba(163,21,21,0.4)' }}
 data-testid={`service-cta-${service.id}`}
 >
 इस साधना के लिए संपर्क करें
 </button>
 </div>
 </SwiperSlide>
 ))}
 </Swiper>
 </div>

 {/* Special Offer */}
 <div className="max-w-4xl mx-auto mt-12">
 <div className="relative p-8 sm:p-10 text-center rounded-2xl bg-gradient-to-br from-[#d4a84b]/10 to-[#d4a84b]/10 border border-[#d4a84b]/30 overflow-hidden">
 <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 via-[#d4a84b] to-[#d4a84b]"></div>
 
 <h3 className="text-2xl sm:text-3xl font-black text-[#D8D2C6] mb-4" style={{ fontFamily: "'Rozha One', serif" }}>
 विशेष प्रस्ताव - <span className="text-[#F3EDE2]">क्षमतानुसार दक्षिणा!</span>
 </h3>
 
 <div className="flex flex-wrap justify-center gap-4 mb-6">
 <div className="p-4 rounded-xl bg-[#250808] border border-[#C9A23A]/40">
 <div className="text-2xl mb-1">❖</div>
 <div className="font-bold text-[#E2C170]">परची से नाम बताएंगी</div>
 <p className="text-xs text-[#0a5e3a]/80">बिना पूछे सब बता देंगी</p>
 </div>
 <div className="p-4 rounded-xl bg-[#0B0B0E] border border-[#d4a84b]/60">
 <div className="text-2xl mb-1">💬</div>
 <div className="font-bold text-[#D8D2C6]">Follow-up Support</div>
 <p className="text-xs text-[#D8D2C6]/80">साधना के बाद 3-6 महीने</p>
 </div>
 </div>
 
 <button 
 className="px-10 py-4 bg-gradient-to-r from-[#f5d77e] to-[#d4a84b] hover:from-[#f5d77e] hover:to-[#f5d77e] text-black text-lg font-black rounded-full shadow-xl shadow-amber-500/30 hover:scale-105 transition-all"
 onClick={scrollToForm}
 style={{ fontFamily: "'Rozha One', serif" }}
 >
 अभी जांच करवाएं - क्षमतानुसार दक्षिणा
 </button>
 
 {/* Aghori Disclaimer */}
 <div className="mt-6 p-4 rounded-xl bg-[#17171C] border border-[#5c1a1a]">
 <p className="text-[#F3EDE2] font-bold text-sm">
 ❖ <span className="text-[#F3EDE2]">अघोर विधि</span> से कार्य होता है। पूरी श्रद्धा-विश्वास हो तभी आएं। जिन्हें विश्वास नहीं, दूर रहें।
 </p>
 <p className="text-[#F3EDE2] font-bold text-sm mt-1">
 ! छल-कपट, दुर्भाव से ना आएं - अच्छे मन से आएं
 </p>
 </div>
 </div>
 </div>
 </div>
 </section>
 );
};

export default UltimateServices;
